import { FC, useContext } from "react";
import FooterText from "../../components/footerText";
import AuthSubHeader from "../../components/authSubHeader";
import { AuthContext } from "src/context/authContext";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import ManufacturerContactAndSafetyInfo from "src/components/manufacturer/manufacturerContactAndSafetyInfo";



const HubPortalManufactureVideo: FC = (): JSX.Element => {

      const {isManufacturer,isUserAuthorized} = useContext(AuthContext);

    return (
        // <div className="container-fluid d-flex flex-fill flex-column body-bg overflow-auto pt-2">
        //     <div className="container">
        //         {isManufacturer ?  <ManufacturerContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} /> : <AuthSubHeader /> }
        //         <div className="d-flex flex-column">
        //             <div className="mt-3">
        //                 <video controls className="w-100" src="/assets/FlexForward_Reporting_Portal_Video_16-12-25.mp4" style={{maxHeight: "500px"}}>
        //                     Your browser does not support the video tag.
        //                 </video>
        //             </div>
        //             <FooterText footerType="black"/>
        //         </div>
        //     </div>
        // </div>
         <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
            {isUserAuthorized && <div className="bg-mist py-2">
                <div className="container-fluid">
                    {isManufacturer ?
                        <ManufacturerContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END}/> :
                        <AuthSubHeader/>}
                </div>
            </div>}

            <div className="container-fluid pt-2 d-flex flex-column flex-fill">
                <div className="mt-3">
                    <video controls className="w-100" src="/assets/FlexForward_Reporting_Portal_Video_16-12-25.mp4" style={{maxHeight: "500px"}}>
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <FooterText footerType="black"/>
        </div>
    );
};

export default HubPortalManufactureVideo;


